export const chatMessages = [
    {text: 'Hello, I am ready to start a session!', isMine: false}, 
    {text: 'Nice! I am calling in 5 minutes', isMine: true},
    {text: 'Thanks', isMine: false},
    {text: 'Test with long messages from me. We need many letters to test it and write more and more useless words. Maybe layout can be broken, but i hope it works', isMine: true}, 
    {text: 'Another long text but from opponent. Its good to fill at least 4 lines in this block', isMine: false},
];

export const graphicPoints = [10, 20, 40, 25, 2, 10, 5, 6, 8, 14];